import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import SearchBox from "../search-box";
import NewsCard from "../events/events-card";
import ReactPaginate from "react-paginate";
import Api from '../../../lib/seam-api';
import CustomSelect from '../select';
import NoResults from '../no-results';
import {fireEnquireOpenEvent} from "../../overlay/enquire";
import MeetingCard from '../../../components/meeting-card';
import InputsDate from '../../../components/inputs/inputs-date';
import seamApi from '../../../lib/seam-api';
import { max } from 'lodash';
import dayjs from 'dayjs';
import MediaHelper from '../../../lib/helpers/media';
import InputsDropdown from '../../../components/inputs/inputs-dropdown';
import humanizeDuration from 'humanize-duration';
import MediaQuery from 'react-responsive';
import { FormatMonths } from '../../../lib/helpers';
import ArrowRight from '../../../icons/arrow-right';

import RenderThisIf from '../../../components/renderIf';

const el = document.getElementById('memberships');

import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

class Memberships extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items : [],
            page: 1,
        };
    }

    componentDidMount() {
        this.fetchItems();
    }

    fetchItems(page = this.state.page) {
        seamApi.memberships().getMemberships({
            per_page: 1000,
            page: 1,
        }).then(({ data }) => {
            this.setState({
                items: data
            })
        })
    }

    render() {
        return (
            <div className="memberships__index">
                { this.state.items?.map((membership, index) => {
                    const getFeaturedImage = () => {
                        const image = membership?.content?.feature_image?.[0];

                        if (image?.file_name === undefined) return '/images/office.png';

                        return MediaHelper.formatPublicPath(`/images/${image?.file_name}`);
                    }

                    return (
                        <div class="membership">
                            <div class="membership__top">
                                <div class="membership__image" style={{ backgroundImage: `url(${getFeaturedImage()})`, backgroundPosition: 'center', backgroundSize: 'cover' }}>
                                    <div class="membership-image__overlay"></div>
                                </div>
                                <div className="membership__details">
                                    <div className="membership__name">{membership?.name}</div>
                                    <div className="membership__price">£{membership?.monthly_price} <span>every</span> {FormatMonths(membership?.renewal_interval_month)}</div>

                                </div>
                            </div>
                            <div class="membership__information">
                                {membership?.content?.features?.map((feature, index) => {
                                    return <div key={index} className="membership-information__item">{ feature?.name }</div>
                                })}
                            </div>
                            <button class="membership__purchase"
                                    onClick={() => window.location.href = `/memberships/${membership.id}`}>Choose This
                                Plan <ArrowRight/></button>
                        </div>
                    )
                })}
            </div>
        );
    }
}

if(el)  {
    ReactDOM.render(<Memberships/>, el);
}
